module.exports = __webpack_public_path__ + "img/icon_notes.9cfb4dcb.svg";